import { render, staticRenderFns } from "./demandDetail.vue?vue&type=template&id=6a88edf1&scoped=true"
import script from "./demandDetail.vue?vue&type=script&lang=js"
export * from "./demandDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a88edf1",
  null
  
)

export default component.exports